import { ChangeDetectionStrategy, Component, HostListener, OnInit } from '@angular/core';

import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { ActionItem, ActionItemStyle, BaseContainer, DialogConfig, DialogRef } from '@stylehaven/components';

@Component({
    standalone: false,
    selector: 'med-no-roles-dialog',
    templateUrl: './no-roles-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoRolesDialogComponent extends BaseContainer implements OnInit {
    public acceptKey = 'actions.accept';
    public messageKey = 'general.no-roles.message';
    public contactAdminKey = 'general.no-roles.contact-admin';

    public navigationItem$: Observable<ActionItem>;

    public mailToServices$: Observable<string>;
    public adminEmail: string;
    public detailUrl: string;
    public login: string;

    constructor(
        public config: DialogConfig,
        public dialog: DialogRef<boolean>
    ) {
        super();
        this.adminEmail = this.config.data?.adminEmail;
        this.detailUrl = this.config.data?.detailUrl;
        this.login = this.config.data?.login;
    }

    @HostListener('document:keydown.enter', ['$event'])
    handleEnter(event: KeyboardEvent) {
        this.submit();
    }

    ngOnInit(): void {
        this.initMailToServicesStream();
        this.initActionItemStream();
    }

    public submit(): void {
        this.dialog.close(true);
    }

    private initActionItemStream(): void {
        this.navigationItem$ = this.mailToServices$.pipe(
            map((mail: string) => ({
                label: this.translateService.translate('actions.contact-admin'),
                eventListener: this.mailToServicesAction.bind(this, mail),
                style: ActionItemStyle.Link
            }))
        );
    }

    private initMailToServicesStream(): void {
        const subject = `${this.translateService.translate('general.no-roles.mail-subject', {
            user: this.login
        })}`;

        this.mailToServices$ = of(
            `mailto:${this.adminEmail}?subject=Issue report: ${subject}&body=${encodeURIComponent(this.detailUrl)}`
        );
    }

    private mailToServicesAction(mail: string): void {
        window.open(mail, '_blank', 'noopener, noreferrer');
    }
}
